import { z } from "zod/v4";
import { currencySchema } from "./common";

export const disputeStatusSchema = z.enum(["open", "won", "lost"]);

export const disputeResponseSchema = z.object({
	id: z.string(),
	stripe_dispute_id: z.string(),
	payment_intent_id: z.string().nullable(),
	invoice_id: z.string().nullable(),
	club_id: z.string(),
	amount_cents: z.number(),
	currency: currencySchema,
	reason: z.string(),
	status: disputeStatusSchema,
	evidence_due_at: z.coerce.date().nullable(),
	created_at: z.coerce.date(),
	resolved_at: z.coerce.date().nullable(),
});

export type DisputeResponse = z.infer<typeof disputeResponseSchema>;
